import { render } from "./HorizontalBreedingValueBar.vue?vue&type=template&id=090a051b"
import script from "./HorizontalBreedingValueBar.vue?vue&type=script&lang=js"
export * from "./HorizontalBreedingValueBar.vue?vue&type=script&lang=js"

import "./HorizontalBreedingValueBar.vue?vue&type=style&index=0&id=090a051b&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__